import React, { createContext, useState, useCallback, useEffect } from 'react';
import api from '../api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }, [token]);

  const register = useCallback(async (email, password, name, userType, company = null, phone = null, acceptedTerms = false) => {
    setLoading(true);
    try {
      const response = await api.post('/api/auth/register', {
        email,
        password,
        name,
        userType,
        company,
        phone,
        acceptedTerms
      });
      if (!response.data.requiresVerification && response.data.token) {
        setUser(response.data.user);
        setToken(response.data.token);
        localStorage.setItem('token', response.data.token);
        api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
      }
      return response.data;
    } catch (error) {
      // Normalize error message for UI
      const msg = error?.response?.data?.error || (error?.response?.data?.errors && error.response.data.errors.map(e=>e.msg).join(', ')) || error.message || 'Registration failed';
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    setLoading(true);
    try {
      const response = await api.post('/api/auth/login', { email, password });
      setUser(response.data.user);
      setToken(response.data.token);
      localStorage.setItem('token', response.data.token);
      api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
      return response.data;
    } catch (error) {
      const msg = error?.response?.data?.error || (error?.response?.data?.errors && error.response.data.errors.map(e=>e.msg).join(', ')) || error.message || 'Login failed';
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('token');
    delete api.defaults.headers.common['Authorization'];
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
